<template>
  <div class="table-wrapper">
    <div class="table-title-wrapper">
      <div class="label-wrapper">
        <div>Software</div>
        <div class="button" @click="buttonClick">Add Software</div>
      </div>
    </div>
    <ag-grid-vue
      style="width: 100%; height: 300px"
      class="ag-theme-material"
      :gridOptions="gridOptions"
      :columnDefs="columnDefs"
      @column-resized="onColumnResized"
      @first-data-rendered="onFirstDataRendered"
      @grid-size-changed="onFirstDataRendered"
      :rowData="rowData"
    ></ag-grid-vue>
  </div>
</template>

<script>
import { db } from "@/vendor/firebase";
import { AgGridVue } from "ag-grid-vue";
import * as database from "@/vendor/database";
import SoftwareActions from "./SoftwareActions";
import SoftwareLogo from "./SoftwareLogo.vue";

export default {
  data() {
    return {
      software: null,
      rowData: [],
      gridOptions: null,
      columnDefs: null,
    };
  },
  components: {
    AgGridVue,
    SoftwareActions,
    SoftwareLogo,
  },
  watch: {
    software: function () {
      this.rowData = (this.software || []).map((item) => ({
        name: item.name,
        price: item.price,
        logo: item.logo,
        id: item.id,
      }));
    },
  },
  beforeMount() {
    this.$bind("software", db.collection("software"));
    this.gridOptions = {
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: true,
        autoHeight: true,
      },
      context: {
        componentParent: this,
      },
      animateRows: true,
      enableCellTextSelection: true,
    };
    this.columnDefs = [
      {
        headerName: "Name",
        field: "name",
      },
      {
        headerName: "Price",
        field: "price",
      },
      {
        headerName: "Logo",
        field: "logo",
        cellRendererFramework: "SoftwareLogo",
        flex: 1,
      },
      {
        headerName: "Actions",
        field: "actions",
        width: 180,
        cellClass: ["overflow-visible", "grid-action-flex"],
        cellRendererFramework: "SoftwareActions",
        sortable: false,
        filter: false,
        rowGroup: false,
      },
    ];
  },
  methods: {
    onColumnResized: function (params) {
      params.api.resetRowHeights();
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    buttonClick: function () {
      this.$emit("buttonClick", { type: "add" });
    },
    deleteSoftware: function (data) {
      if (confirm("do you want to delete?")) {
        const id = data.id;
        database.deleteDoc("software", id).then((response) => {
          if (response.ok) {
            this.$toasted.global.toast_success({
              message: "delete success",
            });
          } else {
            this.$toasted.global.toast_error({ message: "delete error" });
          }
        });
      }
    },
    editSoftware: function (data) {
      this.$emit("buttonClick", { type: "edit", ...data });
    },
  },
};
</script>


<style scoped>
.label-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  font-family: inter-regular;
}
.button {
  padding: 4px 8px;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  font-size: 13px;
  line-height: 20px;
  cursor: pointer;
  font-weight: 500;
  font-family: inter-regular;
}
.table-wrapper {
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 1px rgba(0, 0, 0, 0.06),
    0px 1px 1px rgba(0, 0, 0, 0.08);
}
.table-title-wrapper {
  padding: 24px 24px 6px;
}
</style>
